import React from "react";

import { Card, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
	ticketHeader: {
		display: "flex",
		alignItems: "center",
		background: theme.palette.total,
		flex: "none",
		borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
		height: "65px",
		minHeight: "65px",
		paddingRight: 4,
		overflow: "hidden",
		[theme.breakpoints.down("sm")]: {
			height: "auto",
			minHeight: "calc(52px + env(safe-area-inset-top, 0px))",
			paddingTop: "env(safe-area-inset-top, 0px)",
			flexWrap: "nowrap",
			boxSizing: "border-box",
		},
	},
	backButton: {
		minWidth: 40,
		padding: 8,
		flexShrink: 0,
	},
}));

const TicketHeader = ({ loading, children }) => {
	const classes = useStyles();
	const history = useHistory();

	const handleBack = () => {
		history.push("/tickets");
	};

	return (
		<>
			{loading ? (
				<TicketHeaderSkeleton />
			) : (
				<Card
					square
					elevation={0}
					className={classes.ticketHeader}
				>
					<IconButton
						color="primary"
						onClick={handleBack}
						className={classes.backButton}
						aria-label="voltar"
					>
						<ArrowBackIos fontSize="small" />
					</IconButton>
					{children}
				</Card>
			)}
		</>
	);
};

export default TicketHeader;
